(function () {
  function getTotal() {
    var freqEls = document.querySelectorAll('.jm-review-widget .jm-histogram-row__frequency');
    if (!freqEls.length) return null;
    var sum = 0;
    for (var i = 0; i < freqEls.length; i++) {
      var n = parseInt((freqEls[i].textContent || '').replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) sum += n;
    }
    return sum > 0 ? sum : null;
  }

  function updateCount() {
    var total = getTotal();
    if (total == null) return false;

    var display = document.querySelector('.jm-review-widget-header__average-rating-display');
    if (!display) return false;

    var textNodes = display.querySelectorAll('.jm-text');
    var countEl = textNodes.length ? textNodes[textNodes.length - 1] : null;
    if (!countEl) return false;

    var existing = (countEl.textContent || '').trim();
    var word = existing.replace(/[\d.,\s]/g, '').trim() || 'Bewertungen';
    var newText = total + ' ' + word;
    if (existing !== newText) {
      countEl.textContent = newText;
    }
    return true;
  }

  function start() {
    var tries = 0;
    var iv = setInterval(function () {
      if (updateCount() || ++tries > 80) clearInterval(iv);
    }, 150);

    if (window.MutationObserver) {
      var obs = new MutationObserver(function (records) {
        // skip our own mutations to avoid loops
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          if (t && t.parentElement && t.parentElement.closest && t.parentElement.closest('.jm-review-widget-header__average-rating-display')) {
            // mutation inside the count itself — schedule re-check
          }
        }
        updateCount();
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
